<template>
    <v-flex xs12 sm3>
        <v-layout row mr-2 wrap>
            <v-flex xs6 class="pt-0">
                <permission-tooltip
                        :permission="canCreateProduct"
                        :tooltip="{top: true, bottom: false, attach: false}"
                >
                    <v-btn
                            :disabled="!canCreateProduct()"
                            :href="create_product_link"
                            color="success"
                            large
                            block
                    >
                        {{ 'app.pages.home.add_product' | trans }}
                    </v-btn>
                </permission-tooltip>
            </v-flex>
            <v-flex xs6 class="pt-0">
                <permission-tooltip
                        :permission="canCreateFood"
                        :tooltip="{top: true, bottom: false, attach: false}"
                >
                    <v-btn
                            :disabled="!canCreateFood()"
                            :href="create_food_link"
                            color="success"
                            large
                            block
                    >
                        {{ 'app.pages.home.add_meal' | trans }}
                    </v-btn>
                </permission-tooltip>
            </v-flex>
            <v-flex xs6 class="pt-0">
                <permission-tooltip
                        :permission="canCreatePatient"
                        :tooltip="{top: true, bottom: false, attach: false}"
                >
                    <v-btn
                            :href="create_patient_link"
                            :disabled="!canCreatePatient()"
                            color="success"
                            large
                            block
                    >
                        {{ 'app.add_patient' | trans }}
                    </v-btn>
                </permission-tooltip>
            </v-flex>
            <v-flex xs6 class="pt-0">
                <permission-tooltip
                        :permission="'schema_create'"
                        :tooltip="{top: true, bottom: false, attach: false}"
                >
                    <v-btn
                            :disabled="!hasPermission('schema_create')"
                            :href="create_schema_link"
                            color="success"
                            large
                            block
                    >
                        {{ 'app.add_schema' | trans }}
                    </v-btn>
                </permission-tooltip>
            </v-flex>
            <v-flex xs12>
                <subscription-card-component
                        :current_subscription_type_name="current_subscription_type_name"
                        :last_subscription_end_date="last_subscription_end_date"
                        :account_expires_in="!!account_expires_in ? +account_expires_in : account_expires_in"
                        :buy_subscription_url="buy_subscription_url"
                        :start_discount_url="start_discount_url"
                        :show_start_discount_url="show_start_discount_url"
                />
            </v-flex>
            <v-flex xs12>
                <upcoming-events :calendar_events="calendar_events"/>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {DIETITIAN_FREE, DIETITIAN_TEST} from "../../utils/roles";

export default {
    props: {
        current_subscription_type_name: {
            type: String,
        },
        last_subscription_end_date: {
            type: String
        },
        account_expires_in: {
            type: String
        },
        buy_subscription_url: {
            type: String
        },
        start_discount_url: {
            type: String
        },
        show_start_discount_url: {
            type: Boolean
        },
        create_patient_link: {
            type: String
        },
        create_product_link: {
            type: String
        },
        create_food_link: {
            type: String
        },
        create_schema_link: {
            type: String
        },
        calendar_events: {
            type: Array,
        },
    },
    created() {
        this.fetchOwnFoodsCount();
        this.fetchOwnProductsCount();
        this.fetchPatientsCount();
    },
    computed: {
        ...mapGetters(['hasPermission', 'userRole', 'ownFoodsCount', 'ownProductsCount', 'patientsCount'])
    },
    methods: {
        ...mapActions(['fetchOwnFoodsCount', 'fetchOwnProductsCount', 'fetchPatientsCount']),
        canCreateFood() {
            if (!this.hasPermission('food_own_create')) {
                return false;
            }
            return !((this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) && this.ownFoodsCount >= 20);

        },
        canCreateProduct() {
            if (!this.hasPermission('product_own_create')) {
                return false;
            }
            return !((this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) && this.ownProductsCount >= 20);
        },
        canCreatePatient() {
            if (!this.hasPermission('patient_create')) {
                return false;
            }
            return !((this.userRole === DIETITIAN_FREE || this.userRole === DIETITIAN_TEST) && this.patientsCount >= 5);
        }
    }
}
</script>

<style scoped>
.v-btn {
    margin: 0 0 6px;
}

.v-btn--large {
    height: 48px;
}
</style>
